import React, { ComponentProps } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaTimesCircle } from 'react-icons/fa';

type Props = React.PropsWithoutRef<ComponentProps<typeof Button>>;

const ButtonClear = (props: Props) => {
  const { t, i18n } = useTranslation();

  return (
    <Button
      {...props}
      style={{ minWidth: '140px', fontWeight: 400 }}
      variant="outline-danger"
      onClick={props.onClick}
    >
      <FaTimesCircle className="mb-1" />{' '}
      {i18n.language === 'gr' ? t('Καθάρισμα') : t('Clear')}
    </Button>
  );
};
export default React.memo(ButtonClear);
